// extracted by mini-css-extract-plugin
export default {"searchBar":"Style_searchBar__SRQ9E"};